module.exports = __webpack_public_path__ + "351469620f304102101e7533297aea53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-ucentralcolombia.svg
// module id = 1181
// module chunks = 0